module.exports = __webpack_public_path__ + "img/icon_youtube.svg?version=c8ceca6e";